import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'mapkey',
  pure: false
})
export class MapkeyPipe implements PipeTransform {

  transform(map: Map<any, any>): any {
    return Array.from(map.keys());
  }

}



// WEBPACK FOOTER //
// ./src/app/shared/pipes/mapkey/mapkey.pipe.ts